/* eslint-disable no-dupe-else-if */
/* eslint-disable eqeqeq */
import LAYOUT_CONST from 'constant';

export const JWT_API = {
    secret: 'SECRET-KEY',
    timeout: '1 days'
};

export const FIREBASE_API = {
    apiKey: 'AIzaSyBernKzdSojh_vWXBHt0aRhf5SC9VLChbM',
    authDomain: 'berry-material-react.firebaseapp.com',
    projectId: 'berry-material-react',
    storageBucket: 'berry-material-react.appspot.com',
    messagingSenderId: '901111229354',
    appId: '1:901111229354:web:a5ae5aa95486297d69d9d3',
    measurementId: 'G-MGJHSL8XW3'
};

export const AUTH0_API = {
    client_id: '7T4IlWis4DKHSbG8JAye4Ipk0rvXkH9V',
    domain: 'dev-w0-vxep3.us.auth0.com'
};

export const AWS_API = {
    poolId: 'us-east-1_AOfOTXLvD',
    appClientId: '3eau2osduslvb7vks3vsh9t7b0'
};

// basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
// like '/berry-material-react/react/default'
export const BASE_PATH = '';

export const getDashboardPath = () => {
    let dashBoard = '';
    const role = localStorage.getItem('role');
    const userType = localStorage.getItem('userTypes');
    const mbbsUser = localStorage.getItem('mbbsUser');
    const mbbsPrincipal = localStorage.getItem('mbbsPrincipal');

    // Preserve existing behavior: undefined/null => MBBS-mode; explicit 'false' => regular mode
    const isMBBSUser = mbbsUser === null || mbbsUser === undefined || mbbsUser === 'true';
    const isMBBSPrincipal = mbbsPrincipal === null || mbbsPrincipal === undefined || mbbsPrincipal === 'true';
    const isMBBS = isMBBSUser || isMBBSPrincipal;

    if (role === 'ROLE_STUDENT_ADMISSION') {
        dashBoard = '/student/registration';
    } else if (role === 'ROLE_HIRER') {
        dashBoard = '/company/dashboard';
    } else if (role === 'ROLE_COLLEGE_ADMIN' || role === 'ROLE_ADMIN') {
        dashBoard = '/institute/dashboard';
    } else if (role === 'ROLE_SUPER_ADMIN') {
        dashBoard = '/dashboard/default';
    } else if (role === 'ROLE_COLLEGE_SUB_ADMIN' && userType === 'EXTERNAL_CLIENT') {
        dashBoard = '/external/dashboard';
    } else if (role === 'ROLE_COLLEGE_ADMIN' && userType === 'Dean') {
        dashBoard = '/dean/dashboard';
    } else if (role === 'ROLE_COLLEGE_SUB_ADMIN' && userType === 'HOD') {
        dashBoard = isMBBS ? '/hod/mbbs/dashboard' : '/hod/dashboard';
    } else if (userType === 'Staff') {
        // Staff should use teacher dashboard normally, but MBBS principal users should go to MBBS HOD
        if (isMBBSPrincipal) {
            dashBoard = '/hod/mbbs/dashboard';
        } else {
            dashBoard = '/teacher/dashboard';
        }
    } else if (role === 'ROLE_COLLEGE_SUB_ADMIN' && userType === 'Accountant') {
        dashBoard = '/accountant/dashboard';
    } else if (role === 'ROLE_COLLEGE_SUB_ADMIN' && userType === 'Registrar') {
        dashBoard = '/registrar/dashboard';
    } else if (role === 'ROLE_COLLEGE_SUB_ADMIN' && userType === 'Admission_Handler') {
        dashBoard = '/admission/handler/dashboard';
    } else if (role === 'ROLE_COLLEGE_SUB_ADMIN' && userType === 'DUC') {
        dashBoard = '/duc/dashboard';
    } else if (role === 'ROLE_COLLEGE_SUB_ADMIN' && userType === 'COE') {
        dashBoard = '/management/dashboard';
    } else if (role === 'ROLE_COLLEGE_SUB_ADMIN' && userType === 'SCHOLARSHIP_MANAGER') {
        dashBoard = '/scholarship/dashboard';
    } else if (role === 'ROLE_COLLEGE_SUB_ADMIN' && userType === 'PA') {
        dashBoard = '/pa/dashboard';
    } else if (role === 'ROLE_COLLEGE_SUB_ADMIN' && userType === 'CHANCELLOR') {
        dashBoard = '/management/dashboard';
    } else if (role === 'ROLE_COLLEGE_SUB_ADMIN' && userType === 'PLACEMENT_IN_CHARGE') {
        dashBoard = '/placement/dashboard';
    } else if (role === 'ROLE_STAFF_CANDIDATE' && userType === 'CANDIDATE') {
        dashBoard = '/candidate/dashboard';
    } else if (role === 'ROLE_STUDENT' && userType === 'Student') {
        dashBoard = '/student/dashboard';
    } else if (role === 'ROLE_COLLEGE_SUB_ADMIN' && userType !== 'HOD' && userType !== 'Staff') {
        dashBoard = '/teacher/dashboard';
    } else {
        dashBoard = '/dashboard/default';
    }

    return dashBoard;
};

// For backward compatibility, export DASHBOARD_PATH as the function
export const DASHBOARD_PATH = getDashboardPath;
export const HORIZONTAL_MAX_ITEM = 6;

const config = {
    layout: LAYOUT_CONST.VERTICAL_LAYOUT, // vertical, horizontal
    drawerType: LAYOUT_CONST.DEFAULT_DRAWER, // default, mini-drawer
    fontFamily: `'Plus Jakarta Sans', sans-serif`,
    borderRadius: 8,
    outlinedFilled: true,
    navType: 'light', // light, dark
    presetColor: 'default', // default, theme1, theme2, theme3, theme4, theme5, theme6
    locale: 'en', // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
    rtlLayout: false,
    container: false
};

export default config;
